import dayjs from 'dayjs';

export const differenceInYears = (dt1: Date | string, dt2: Date | string) =>
  dayjs(dt1).diff(dayjs(dt2), 'year');

export const dateDifferenceText = (data: string | Date) => {
  if (!data) return '';

  const endingDate = new Date(data);
  let startDate = new Date();
  let endDate = new Date(endingDate);

  if (startDate > endDate) {
    const swap = startDate;
    startDate = endDate;
    endDate = swap;
  }
  const startYear = startDate.getFullYear();

  const february =
    (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
      ? 29
      : 28;

  const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  let yearDiff = endDate.getFullYear() - startYear;
  let monthDiff = endDate.getMonth() - startDate.getMonth();
  if (monthDiff < 0) {
    yearDiff--;
    monthDiff += 12;
  }
  let dayDiff = endDate.getDate() - startDate.getDate();
  if (dayDiff < 0) {
    if (monthDiff > 0) {
      monthDiff--;
    } else {
      yearDiff--;
      monthDiff = 11;
    }
    dayDiff += daysInMonth[startDate.getMonth()];
  }

  return yearDiff + ' Ano(s) ' + monthDiff + ' Mes(es) ' + dayDiff + ' Dia(s)';
};

export const getAge = (dateString: string | Date): number => {
	const today = new Date();
	const birthDate = new Date(dateString);
	let age = today.getFullYear() - birthDate.getFullYear();
	const m = today.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
		age--;
	}
  if(isNaN(age)) return null
	return age;
};